module.exports = __webpack_public_path__ + "static/ai-696c634045b797804be6cd7114d8aa4b.svg";